import { Link } from "react-router-dom";
import Logo from "../components/Logo";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-[#E5E7EB] bg-white">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-4 sm:h-20 sm:px-6">
          <Link to="/login" className="flex items-center gap-2" data-testid="privacy-header-logo">
            <Logo className="h-12 w-auto sm:h-14" />
          </Link>
          <Link
            to="/login"
            className="maven-btn-secondary"
            data-testid="privacy-back-to-login"
          >
            Torna al login
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-12" data-testid="privacy-content">
        <div className="mb-8">
          <h1 className="text-2xl font-bold tracking-tight text-[#1F2937] sm:text-3xl">
            Informativa sul trattamento dei dati personali
          </h1>
          <p className="mt-1 text-sm text-[#0153A3] font-semibold">Maven Academy</p>
          <p className="mt-2 text-sm text-[#6B7280]">
            ai sensi dell'art. 13 del Regolamento (UE) 2016/679 ("GDPR")
          </p>
          <p className="mt-1 text-xs text-[#9CA3AF]">Ultimo aggiornamento: 30 settembre 2026</p>
        </div>

        <div className="prose-maven space-y-8 text-[15px] leading-relaxed text-[#1F2937]">
          <Section n="1" title="Titolare del trattamento">
            <p>Il Titolare del trattamento è:</p>
            <p className="mt-2">
              <strong>Maven Pharma S.r.l.</strong>
              <br />
              Sede legale: Via Stefano Jacini 68, 00191 Roma (RM)
              <br />
              P. IVA: 10901681006
            </p>
            <p className="mt-2">Contatto per richieste relative alla protezione dei dati personali:</p>
            <p className="mt-1">
              <a href="mailto:info@mavenpharma.com" className="font-semibold text-[#0153A3] hover:underline">
                info@mavenpharma.com
              </a>
            </p>
            <p className="mt-3">
              Maven Academy è una piattaforma aziendale ad accesso riservato destinata esclusivamente a dipendenti, collaboratori e consulenti/ISF autorizzati da Maven Pharma S.r.l.
            </p>
          </Section>

          <Section n="2" title="Categorie di dati trattati">
            <p>Nell'ambito dell'utilizzo di Maven Academy possono essere trattate le seguenti categorie di dati personali:</p>
            <Sub title="a) Dati identificativi e professionali">
              <ul className="list-disc pl-5">
                <li>nome e cognome, ove inseriti;</li>
                <li>indirizzo e-mail;</li>
                <li>ruolo assegnato all'interno della piattaforma;</li>
                <li>appartenenza alla categoria ADMIN o ISF;</li>
                <li>stato dell'account.</li>
              </ul>
            </Sub>
            <Sub title="b) Dati di autenticazione">
              <ul className="list-disc pl-5">
                <li>informazioni necessarie alla creazione e gestione dell'account;</li>
                <li>credenziali e informazioni tecniche necessarie all'autenticazione;</li>
                <li>informazioni relative al recupero e alla modifica della password.</li>
              </ul>
              <p className="mt-2">
                Le password sono gestite attraverso il sistema di autenticazione utilizzato dalla piattaforma e non sono mostrate agli amministratori dell'applicazione in chiaro.
              </p>
            </Sub>
            <Sub title="c) Dati tecnici relativi all'utilizzo del servizio">
              <p>
                Durante l'utilizzo della piattaforma possono essere generati dati tecnici strettamente necessari al funzionamento e alla sicurezza del servizio, quali, ove effettivamente registrati dall'infrastruttura:
              </p>
              <ul className="mt-2 list-disc pl-5">
                <li>indirizzo IP;</li>
                <li>data e ora delle operazioni;</li>
                <li>browser e dispositivo utilizzato;</li>
                <li>log tecnici e di sicurezza;</li>
                <li>informazioni relative alla sessione di autenticazione.</li>
              </ul>
            </Sub>
            <Sub title="d) Contenuti aziendali">
              <p>
                Gli amministratori possono caricare nella piattaforma documenti, immagini, video e altro materiale aziendale.
                Qualora tali materiali contengano incidentalmente dati personali, essi saranno trattati esclusivamente nell'ambito delle finalità aziendali per le quali il materiale è stato caricato.
              </p>
            </Sub>
          </Section>

          <Section n="3" title="Finalità del trattamento">
            <p>I dati vengono trattati esclusivamente per:</p>
            <ul className="mt-2 list-disc pl-5">
              <li>creare e gestire gli account autorizzati;</li>
              <li>consentire l'accesso sicuro a Maven Academy;</li>
              <li>distinguere i diversi livelli di autorizzazione ADMIN e ISF;</li>
              <li>consentire la consultazione dei materiali aziendali;</li>
              <li>gestire il recupero e la modifica delle password;</li>
              <li>garantire la sicurezza informatica della piattaforma;</li>
              <li>prevenire accessi non autorizzati o utilizzi impropri;</li>
              <li>gestire eventuali problemi tecnici;</li>
              <li>adempiere ad eventuali obblighi di legge applicabili.</li>
            </ul>
            <p className="mt-3">
              Maven Academy non è utilizzata per finalità pubblicitarie o di marketing verso gli utenti della piattaforma.
            </p>
          </Section>

          <Section n="4" title="Base giuridica del trattamento">
            <p>Il trattamento dei dati personali necessario all'utilizzo della piattaforma si fonda, a seconda dei casi, su:</p>
            <ul className="mt-2 list-disc pl-5">
              <li>art. 6, par. 1, lett. b) GDPR, in quanto necessario all'esecuzione del rapporto di lavoro, collaborazione o consulenza e delle attività connesse;</li>
              <li>art. 6, par. 1, lett. f) GDPR, sulla base del legittimo interesse di Maven Pharma S.r.l. a organizzare le proprie attività, mettere a disposizione dei soggetti autorizzati materiali aziendali e proteggere sistemi, informazioni e risorse aziendali;</li>
              <li>art. 6, par. 1, lett. c) GDPR, qualora il trattamento sia necessario per adempiere ad obblighi di legge.</li>
            </ul>
            <p className="mt-3">Il funzionamento ordinario della piattaforma non è basato sul consenso dell'utente.</p>
          </Section>

          <Section n="5" title="Natura del conferimento dei dati">
            <p>
              Il conferimento dei dati necessari alla creazione dell'account e all'autenticazione è necessario per utilizzare Maven Academy.
            </p>
            <p className="mt-2">
              L'eventuale mancato conferimento dei dati indispensabili comporta l'impossibilità di accedere alla piattaforma.
            </p>
          </Section>

          <Section n="6" title="Soggetti autorizzati e destinatari dei dati">
            <p>
              I dati possono essere trattati, nei limiti delle rispettive mansioni, da personale, collaboratori o consulenti di Maven Pharma S.r.l. espressamente autorizzati.
            </p>
            <p className="mt-2">
              Maven Pharma può inoltre avvalersi di fornitori di servizi informatici che trattano dati per conto della società, ad esempio per:
            </p>
            <ul className="mt-2 list-disc pl-5">
              <li>hosting dell'applicazione;</li>
              <li>autenticazione;</li>
              <li>database;</li>
              <li>archiviazione dei file;</li>
              <li>sicurezza e manutenzione dell'infrastruttura.</li>
            </ul>
            <p className="mt-3">
              Tra i fornitori tecnici della piattaforma rientra Supabase, utilizzato per servizi quali autenticazione, database e storage. L'applicazione è attualmente ospitata sull'infrastruttura Emergent, che opera in qualità di fornitore di hosting.
            </p>
            <p className="mt-3">
              I fornitori che trattano dati personali per conto di Maven Pharma sono utilizzati in conformità alla normativa applicabile in materia di protezione dei dati.
            </p>
          </Section>

          <Section n="7" title="Ubicazione e trasferimento dei dati">
            <p>
              Il database e lo storage Supabase utilizzati da Maven Academy sono attualmente configurati nella regione europea West EU (Ireland).
            </p>
            <p className="mt-2">
              Alcuni fornitori tecnologici possono essere società stabilite al di fuori dello Spazio Economico Europeo oppure utilizzare sub-responsabili internazionali.
            </p>
            <p className="mt-2">
              Qualora il trattamento comporti trasferimenti di dati personali verso Paesi terzi, Maven Pharma utilizza i meccanismi previsti dal Capo V del GDPR applicabili al relativo trasferimento, quali decisioni di adeguatezza o clausole contrattuali standard approvate dalla Commissione europea, ove necessario.
            </p>
            <p className="mt-2">Ulteriori informazioni sulle garanzie utilizzate possono essere richieste scrivendo a:</p>
            <p className="mt-1">
              <a href="mailto:info@mavenpharma.com" className="font-semibold text-[#0153A3] hover:underline">
                info@mavenpharma.com
              </a>
            </p>
          </Section>

          <Section n="8" title="Conservazione dei dati">
            <p>
              I dati relativi all'account vengono conservati per il periodo in cui l'utente è autorizzato ad utilizzare Maven Academy.
            </p>
            <p className="mt-2">
              Quando il rapporto di lavoro, collaborazione o consulenza termina, oppure quando viene meno la necessità di accesso alla piattaforma, l'account può essere disattivato o eliminato.
            </p>
            <p className="mt-2">
              Eventuali dati tecnici, log di sicurezza e informazioni necessarie alla gestione di incidenti vengono conservati esclusivamente per il periodo necessario alle relative finalità, nel rispetto delle configurazioni e delle politiche di conservazione applicabili ai servizi utilizzati.
            </p>
            <p className="mt-2">I dati potranno essere conservati più a lungo qualora ciò sia necessario per:</p>
            <ul className="mt-2 list-disc pl-5">
              <li>adempiere ad obblighi di legge;</li>
              <li>tutelare i diritti di Maven Pharma;</li>
              <li>gestire controversie o incidenti di sicurezza.</li>
            </ul>
          </Section>

          <Section n="9" title="Misure di sicurezza">
            <p>Maven Pharma adotta misure tecniche e organizzative appropriate finalizzate a proteggere i dati personali da:</p>
            <ul className="mt-2 list-disc pl-5">
              <li>accesso non autorizzato;</li>
              <li>perdita;</li>
              <li>distruzione;</li>
              <li>modifica;</li>
              <li>divulgazione non autorizzata.</li>
            </ul>
            <p className="mt-3">Maven Academy utilizza, tra le altre misure:</p>
            <ul className="mt-2 list-disc pl-5">
              <li>autenticazione individuale degli utenti;</li>
              <li>gestione dei ruoli e delle autorizzazioni;</li>
              <li>accesso riservato ai contenuti;</li>
              <li>storage privato per i materiali aziendali;</li>
              <li>collegamenti temporanei firmati per l'accesso ai file, ove applicabile;</li>
              <li>connessioni protette tramite HTTPS.</li>
            </ul>
          </Section>

          <Section n="10" title="Cookie e tecnologie necessarie al funzionamento">
            <p>
              Maven Academy utilizza esclusivamente, allo stato attuale, cookie o tecnologie equivalenti strettamente necessarie al funzionamento della piattaforma, alla gestione delle sessioni, all'autenticazione e alla sicurezza del servizio.
            </p>
            <p className="mt-2">
              Tali strumenti possono comprendere cookie tecnici, local storage o tecnologie analoghe necessarie al mantenimento della sessione dell'utente e al funzionamento della web app/PWA.
            </p>
            <p className="mt-2">Non vengono attualmente utilizzati:</p>
            <ul className="mt-2 list-disc pl-5">
              <li>cookie pubblicitari;</li>
              <li>cookie di profilazione;</li>
              <li>strumenti destinati alla pubblicità comportamentale;</li>
              <li>sistemi di profilazione commerciale degli utenti;</li>
              <li>sistemi analytics opzionali destinati al monitoraggio individuale degli utenti.</li>
            </ul>
            <p className="mt-3">
              Per gli strumenti strettamente tecnici necessari al funzionamento del servizio non viene richiesto un consenso preventivo.
            </p>
            <p className="mt-2">
              Qualora in futuro Maven Pharma introduca strumenti analytics, cookie o altre tecnologie non strettamente necessarie, la presente informativa e, ove necessario, il sistema di gestione del consenso saranno aggiornati prima della loro attivazione.
            </p>
          </Section>

          <Section n="11" title="Processi decisionali automatizzati e profilazione">
            <p>
              Maven Academy non utilizza processi decisionali automatizzati che producano effetti giuridici o effetti analogamente significativi sugli utenti.
            </p>
            <p className="mt-2">La piattaforma non effettua profilazione degli utenti per finalità pubblicitarie o commerciali.</p>
          </Section>

          <Section n="12" title="Diritti dell'interessato">
            <p>L'interessato può esercitare, nei casi previsti dal GDPR, i diritti di cui agli artt. 15-22 del Regolamento, tra cui:</p>
            <ul className="mt-2 list-disc pl-5">
              <li>ottenere conferma dell'esistenza di dati personali che lo riguardano;</li>
              <li>accedere ai propri dati;</li>
              <li>richiederne la rettifica;</li>
              <li>richiederne la cancellazione, nei casi previsti dalla legge;</li>
              <li>richiedere la limitazione del trattamento;</li>
              <li>opporsi al trattamento nei casi previsti;</li>
              <li>richiedere la portabilità dei dati, ove applicabile.</li>
            </ul>
            <p className="mt-3">Le richieste possono essere inviate a:</p>
            <p className="mt-1">
              <a href="mailto:info@mavenpharma.com" className="font-semibold text-[#0153A3] hover:underline">
                info@mavenpharma.com
              </a>
            </p>
          </Section>

          <Section n="13" title="Reclamo all'autorità di controllo">
            <p>L'interessato ha inoltre il diritto di proporre reclamo all'autorità di controllo competente.</p>
            <p className="mt-2">
              Per l'Italia: <strong>Garante per la protezione dei dati personali</strong>.
            </p>
            <p className="mt-2">
              Resta salva la possibilità di rivolgersi all'autorità giudiziaria secondo quanto previsto dalla normativa applicabile.
            </p>
          </Section>

          <Section n="14" title="Modifiche all'informativa">
            <p>La presente informativa potrà essere aggiornata qualora vengano modificati:</p>
            <ul className="mt-2 list-disc pl-5">
              <li>le funzionalità della piattaforma;</li>
              <li>le modalità di trattamento;</li>
              <li>i fornitori tecnologici;</li>
              <li>la normativa applicabile.</li>
            </ul>
            <p className="mt-3">
              La versione aggiornata sarà sempre disponibile alla pagina:{" "}
              <Link to="/privacy-policy" className="font-semibold text-[#0153A3] hover:underline">
                /privacy-policy
              </Link>
            </p>
          </Section>
        </div>

        <div className="mt-10 flex justify-center">
          <Link to="/login" className="maven-btn-primary" data-testid="privacy-bottom-back-to-login">
            Torna al login
          </Link>
        </div>
      </main>

      <footer className="border-t border-[#E5E7EB] bg-white px-4 py-4 text-center text-xs text-[#6B7280] sm:px-6">
        © 2026 Maven Pharma S.r.l.
      </footer>
    </div>
  );
}

function Section({ n, title, children }) {
  return (
    <section aria-labelledby={`sec-${n}`}>
      <h2 id={`sec-${n}`} className="mb-3 text-lg font-bold text-[#1F2937] sm:text-xl">
        <span className="mr-2 text-[#0153A3]">{n}.</span>
        {title}
      </h2>
      <div className="text-[15px] leading-relaxed text-[#1F2937]">{children}</div>
    </section>
  );
}

function Sub({ title, children }) {
  return (
    <div className="mt-4">
      <h3 className="mb-1 text-sm font-semibold text-[#1F2937]">{title}</h3>
      <div className="text-[14px] leading-relaxed text-[#374151]">{children}</div>
    </div>
  );
}
